import { Navigate } from 'react-router-dom';

import { consumePendingRedirect } from '../hooks/usePendingRedirect';
import { useSelectedStore } from '../stores/useSelected';

export const WorkspaceContextRedirect = () => {
    const { workspace, project } = useSelectedStore();

    const pendingRedirect = consumePendingRedirect(workspace?.id);
    if (pendingRedirect) {
        return <Navigate to={pendingRedirect} replace />;
    }

    if (workspace?.id && project?.id) {
        return <Navigate to={`/w/${workspace.id}/p/${project.id}`} replace />;
    }

    if (workspace?.id) {
        return <Navigate to={`/w/${workspace.id}`} replace />;
    }

    return <Navigate to="/w" replace />;
};
